import QuestionCreationNav from "pages/QuestionPage/questionCreation/QuestionCreationNav/QuestionCreationNav";

export default QuestionCreationNav;
